import {
    SHOPCRATE_API_URL
} from "@shopcrate/shopcrate-framework";

const isDevelopment = SHOPCRATE_API_URL !== "api.shopcrate.nl";

export default isDevelopment;
